import {Routes} from '@angular/router';
import {LandingComponent} from '@features/landing/landing.component';
import {authGuard} from '@core/guards/auth.guard';

export const routes: Routes = [
  // Public splash — must use pathMatch:'full' so it only catches exactly '/'
  // and does NOT intercept child routes like /overview or /institution/*
  {
    path: '',
    component: LandingComponent,
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('@features/auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('@features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    path: 'init',
    canActivate: [authGuard],
    loadComponent: () => import('@features/init/init.component').then(m => m.InitComponent),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadChildren: () => import('@features/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
